import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Eyebrow, Pill, SectionStamp } from '../components/Atoms';
import Icon from '../components/Icon';
import { fonts } from '../theme';

const CARE = [
  { ic: 'spine', title: 'Orthopaedic', n: '01' },
  { ic: 'brain', title: 'Neurological', n: '02' },
  { ic: 'baby', title: 'Paediatric', n: '03' },
  { ic: 'cane', title: 'Geriatric', n: '04' },
  { ic: 'bandage', title: 'Post-op rehab', n: '05' },
  { ic: 'home', title: 'Home visits', n: '+', mint: true },
];

const STATS = [
  { k: '4+', v: 'years of clinical practice' },
  { k: '5', v: 'specialties under one roof' },
  { k: 'Home', v: 'visits across Vadodara' },
  { k: '24h', v: 'reply on WhatsApp' },
];

export default function HomeTablet({ t }) {
  const navigate = useNavigate();

  return (
    <div style={{
      width: '100%', minHeight: '100vh', background: t.paper, color: t.ink,
      fontFamily: fonts.sans, position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '20px max(36px, 3vw)',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 28, height: 28, borderRadius: 999, background: t.ink, color: t.paper,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: fonts.serif, fontSize: 14, fontStyle: 'italic',
          }}>m</div>
          <div style={{ fontFamily: fonts.serif, fontSize: 15 }}>Dr. Moksha Patel</div>
        </Link>
        <Pill
          t={t} icon="calendar" fill={t.ink} ink={t.paper}
          style={{ padding: '10px 16px', fontSize: 13 }}
          onClick={() => navigate('/book')}
        >
          Book
        </Pill>
      </div>

      <div style={{
        background: t.ink, color: t.paper,
        padding: '44px max(36px, 3vw) 36px', position: 'relative',
      }}>
        <Eyebrow t={t} color={t.mint}>Physiotherapy · Vadodara</Eyebrow>
        <div style={{
          display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: 32,
          alignItems: 'center', marginTop: 24,
        }}>
          <div>
            <h1 style={{
              fontFamily: fonts.serif, fontWeight: 300,
              fontSize: 'clamp(56px, 9vw, 84px)', lineHeight: 0.92,
              letterSpacing: '-0.04em', margin: 0, color: t.paper,
            }}>
              Move <span style={{ fontStyle: 'italic', color: t.mint }}>better,</span><br/>heal slower.
            </h1>
            <p style={{
              fontSize: 14, lineHeight: 1.55, color: 'rgba(246,243,236,0.72)',
              marginTop: 22, maxWidth: 360,
            }}>
              Hands-on physiotherapy &mdash; orthopaedic, neuro, paediatric &amp; post-op care, at the clinic or in your home.
            </p>
            <div style={{ display: 'flex', gap: 10, marginTop: 24, flexWrap: 'wrap' }}>
              <Pill t={t} fill={t.mint} ink={t.ink} icon="calendar" onClick={() => navigate('/book')}>
                Book a session
              </Pill>
              <Pill
                t={t} fill="transparent" ink={t.paper}
                style={{ border: `1px solid rgba(255,255,255,0.2)` }}
                onClick={() => navigate('/about')}
              >
                Learn more
              </Pill>
            </div>
          </div>
          <div style={{
            height: 320, borderRadius: 12, position: 'relative', overflow: 'hidden',
            background: `radial-gradient(70% 60% at 50% 30%, ${t.tint}aa, ${t.ink})`,
          }}>
            <img src={`${process.env.PUBLIC_URL}/assets/hero.webp`} alt="Dr. Moksha Patel" style={{
              position: 'absolute', inset: 0, width: '100%', height: '100%',
              objectFit: 'contain', objectPosition: 'center bottom',
            }}/>
          </div>
        </div>
      </div>

      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
        padding: '32px max(36px, 3vw)', borderBottom: `0.5px solid ${t.hair}`,
      }}>
        {STATS.map((s, i) => (
          <div key={i} style={{
            borderLeft: i ? `0.5px solid ${t.hair}` : 'none',
            paddingLeft: i ? 20 : 0,
          }}>
            <div style={{
              fontFamily: fonts.serif, fontSize: 'clamp(32px, 4vw, 40px)', fontWeight: 300,
              lineHeight: 1, letterSpacing: '-0.035em',
            }}>{s.k}</div>
            <div style={{ fontFamily: fonts.sans, fontSize: 12, color: t.muted, marginTop: 8 }}>
              {s.v}
            </div>
          </div>
        ))}
      </div>

      <div style={{ padding: '48px max(36px, 3vw)' }}>
        <SectionStamp n="01" label="Care" t={t}/>
        <h2 style={{
          fontFamily: fonts.serif, fontSize: 'clamp(32px, 5vw, 40px)', fontWeight: 300,
          letterSpacing: '-0.035em', lineHeight: 1.05,
          margin: '14px 0 28px', maxWidth: 540,
        }}>
          Five practices, <span style={{ fontStyle: 'italic' }}>one</span> method.
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {CARE.map((c, i) => (
            <div key={i} style={{
              padding: 22, borderRadius: 14,
              background: c.mint ? t.mint : 'transparent',
              border: c.mint ? 'none' : `0.5px solid ${t.hair}`,
              display: 'flex', alignItems: 'center', gap: 14,
              cursor: 'pointer',
            }}
            onClick={() => navigate(c.mint ? '/contact' : '/services')}
            >
              <Icon name={c.ic} size={22} sw={1.5}/>
              <div style={{ flex: 1, fontFamily: fonts.serif, fontSize: 20 }}>{c.title}</div>
              <span style={{
                fontFamily: fonts.mono, fontSize: 10,
                color: c.mint ? t.mintDeep : t.muted, letterSpacing: '0.16em',
              }}>{c.n}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{
        padding: '36px max(36px, 3vw)', background: t.ink, color: t.paper,
      }}>
        <div style={{
          display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr', gap: 28,
        }}>
          <div>
            <div style={{ fontFamily: fonts.serif, fontSize: 22, fontWeight: 300 }}>
              Dr. Moksha Patel{' '}
              <span style={{ fontStyle: 'italic', color: t.mint }}>(PT)</span>
            </div>
            <div style={{
              fontSize: 12, color: 'rgba(246,243,236,0.55)', marginTop: 10, maxWidth: 280,
            }}>
              A movement-first physiotherapy practice in Vadodara, Gujarat. License GPC-21250.
            </div>
          </div>
          <div>
            <div style={{
              fontFamily: fonts.mono, fontSize: 10, letterSpacing: '0.18em',
              textTransform: 'uppercase', color: t.mint, marginBottom: 12,
            }}>Visit</div>
            {['Clinic — Vadodara', 'Home visits', 'Booking'].map(i => (
              <div key={i} style={{
                fontSize: 12.5, color: 'rgba(246,243,236,0.7)', padding: '4px 0',
              }}>{i}</div>
            ))}
          </div>
          <div>
            <div style={{
              fontFamily: fonts.mono, fontSize: 10, letterSpacing: '0.18em',
              textTransform: 'uppercase', color: t.mint, marginBottom: 12,
            }}>Reach</div>
            {['+91 6353 937 571', 'moxapatel1908@gmail.com', '@moksha.physio'].map(i => (
              <div key={i} style={{
                fontSize: 12.5, color: 'rgba(246,243,236,0.7)', padding: '4px 0',
                wordBreak: 'break-word',
              }}>{i}</div>
            ))}
          </div>
        </div>
      </div>

      <a
        href={`https://wa.me/916353937571?text=${encodeURIComponent("Hi Dr. Moksha, I'd like to ask about physiotherapy.")}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Dr. Moksha"
        style={{
          position: 'fixed', right: 28, bottom: 28, zIndex: 30,
          width: 56, height: 56, borderRadius: 999,
          background: '#25D366', color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 10px 24px rgba(37,211,102,0.4)',
          textDecoration: 'none',
        }}
      >
        <Icon name="whatsapp" size={28} stroke="#fff"/>
      </a>
    </div>
  );
}
